import { createUseStyles } from 'react-jss';

const styles = {
  dialog: { minWidth: '30%' },
  tableViewColumn: { width: '75% !important' },
  tableSubscribeColumn: { display: 'block !important', textAlign: 'center !important' },
  standardViewTitle: { color: 'grey' }
};

export const useStyles = createUseStyles(styles, {
  name: 'ManageSubscriptionsDialog'
});
